module.exports = __webpack_public_path__ + "static/img/IMG_0006.2876044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_slider/IMG_0006.jpg
// module id = GE2g
// module chunks = 0